<template>
  <h1 class="info-section-heading"><slot/></h1>
</template>

<script>
export default {
  name: 'InfoSectionHeading'
}
</script>

<style lang="scss" scoped>
.info-section-heading {
  font-family: 'Signika', sans-serif;
  font-size: 36px;
  font-weight: 700;
  padding: 5px 0;

  a {
    text-decoration: none;
  }
}
</style>


